import React from 'react'
import YearField from 'components/forms/YearField'
import MonthField from 'components/forms/MonthField'
import { Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import styles from './_expiresField.css'
import { connect } from 'react-redux'
import fieldProps from 'components/forms/fieldProps'
import FieldLabel from 'components/forms/FieldLabel'
import FieldError from 'components/forms/FieldError'
import * as premium from 'services/premium/selectors'

const mapStateToProps = (state, formName) => ({
  fields: premium.selectCreditCardFields(formName)(state),
})

export const ExpiresField = (props) => {
  const { required, disabled, fields, input: { name }, meta: { error }} = props
  const monthTouched = fields && fields[`${name}_month`] && fields[`${name}_month`].touched
  const yearTouched = fields && fields[`${name}_year`] && fields[`${name}_year`].touched
  const touched = monthTouched && yearTouched
  const showError = Boolean(touched && error)

  return (
    <div className={styles.container}>

      <FieldLabel
        required
        labelComponent={(
          <FormattedMessage
            id='premium.expires_field.label'
            defaultMessage='Expires'
          />
        )}
      />

      <div className={styles.fields}>

        <MonthField
          slim
          className={styles.month}
          required={required}
          name={`${name}_month`}
          disabled={disabled}
          forceError={showError}
        />

        <YearField
          slim
          className={styles.year}
          name={`${name}_year`}
          required={required}
          disabled={disabled}
          forceError={showError}
        />

      </div>

      <FieldError
        showError={showError}
        errorMessage={error}
        errorComponent={(
          <FormattedMessage
            id='premium.checkout.expiry_invalid'
            defaultMessage='Invalid expiration date'
          />
        )}
      />

    </div>
  )
}

ExpiresField.propTypes = fieldProps

export const ConnectedExpiresField = connect(mapStateToProps)(ExpiresField)
export const renderField = (field) => <ConnectedExpiresField {...field} />
export const FieldWrapper = (props) => <Field {...props} component={renderField} />

export default FieldWrapper
